import { api, scope } from 'cssapi'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import StarLogo from '../shared/StarLogo'
import HLayout from '../shared/layouts/HLayout'
import VLayout from '../shared/layouts/VLayout'
import TextLink from '../shared/links/TextLink'
import spinOnYAxis from '../styles/animations/spinOnYAxis'

const Four = styled.div``
const LogoWrapper = styled.div``

const Header = styled(HLayout.withComponent(`header`))`
  animation: ${spinOnYAxis(3)} 3s cubic-bezier(0.165, 0.84, 0.44, 1);
  align-items: center;
  ${api({
    baseline: scope`s:giant`,
    fontWeight: 600,
    fontFamily: `f:title`,
    marginH: `auto`,
  })};
`

const Layout = styled(VLayout).attrs({ spacing: `large` })`
  text-align: center;

  ${LogoWrapper} {
    position: relative;
    ${api({
      width: [90, 150],
      top: scope`-1ru`,
    })};
  }
`

const Body = styled.div``

const NotFoundMessage = ({ path }) => (
  <Layout spacing="large">
    <Header spacing="none">
      <Four>4</Four>
      <LogoWrapper>
        <StarLogo />
      </LogoWrapper>
      <Four>4</Four>
    </Header>
    <Body>
      <p>There was no page at that address.</p>
      <p>
        Would you like to go to the <TextLink to="/">Home page</TextLink>?
      </p>
    </Body>
  </Layout>
)

NotFoundMessage.propTypes = {
  path: PropTypes.string.isRequired,
}

export default NotFoundMessage



// WEBPACK FOOTER //
// ./src/components/FourOhFourPage/NotFoundMessage.jsx